import "../css/app.css";

// Toggling the "is-active" class on both the "navbar-burger" and the "navbar-menu"
// based on Bulma's standard implementation: https://bulma.io/documentation/components/navbar/#navbar-menu
function toggleNavbar() {
  const burgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  burgers.forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const target = el.dataset.target;
      const $target = document.getElementById(target);

      if ($target) {
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

        // Toggle aria-expanded for accessibility
        const isActive = el.classList.contains('is-active');
        el.setAttribute('aria-expanded', isActive);
      }
    });
  });
}

function handleNotifications() {
  const deletes = Array.prototype.slice.call(document.querySelectorAll('.notification .delete'), 0);

  deletes.forEach(el => {
    const $notification = el.parentNode;
    el.addEventListener('click', () => {
      $notification.parentNode.removeChild($notification);
    });
  });
}

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

function keepAlive() {
  const PING_INTERVAL = 30000; // 30 seconds
  const host = document.body.dataset.host;
  const festsHost = document.body.dataset.festsHost;
  const endpoints = [
    `//${host}/api/v1/ping`,
    `//${festsHost}/api/v1/ping`
  ];


  let intervalId = null;

  const doPings = () => {
    endpoints.forEach(endpoint => {
      const url = `${endpoint}?_=${new Date().getTime()}`;
      console.log("Pinging:", url);
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.result !== 'OK') {
            console.warn(`Keep-alive ping failed for ${endpoint}:`, data);
          }
        })
        .catch(error => {
          console.error(`Error during keep-alive ping for ${endpoint}:`, error);
        });
    });
  };

  const startTimer = () => {
    if (intervalId) return;
    doPings();
    intervalId = setInterval(doPings, PING_INTERVAL);
  };

  const stopTimer = () => {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  document.addEventListener("visibilitychange", async () => {
    if (document.visibilityState === "visible") {
      // If the user wants to click on something immediately, the ping slows that load.
      // So we wait a bit before starting the timer.
      await sleep(15000);
      startTimer();
    } else {
      stopTimer();
    }
  });

  // Initial start if visible
  if (document.visibilityState === "visible") {
    startTimer();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  toggleNavbar();
  handleNotifications();
  keepAlive();
});
